<form
  [formGroup]="form"
  novalidate
  *ngIf="localActivity && localActivity.model"
>
  <div class="d-flex justify-content-between align-items-start">
    <h6 class="align-self-center">
      Form Data
    </h6>
    <div class="row justify-content-between">
      <div class="col">
        <div class="btn-group">
          <wm-form-activity-data-entities-bulk-actions
            [dataEntities]="
              filterEntities(
                sortEntities(localActivity.model.formLayoutModel.columnEntities)
              )
            "
            [workflow]="workflow"
            [activity]="activity"
            (saveActivity)="onSaved($event)"
            [saving]="saving"
          >
          </wm-form-activity-data-entities-bulk-actions>

          <div class="btn-group" ngbDropdown>
            <wm-activity-details-modal
              *ngIf="newDEForm"
              [title]="localActivity.model.screenName + ' - New Data Entity'"
              btnText="Add New Data Entity"
              moduleId="modal-new-entity"
              btnClass="btn btn-primary"
              [form]="newDEForm"
              (saved)="saveNew()"
              (canceled)="cancelNew()"
              (opened)="loadEditor()"
              [disabled]="_workflowSvc.designerVersionMode || saving"
            >
              <wm-data-entity-editor
                *ngIf="showEditor"
                #newDEEditor
                [workflow]="workflow || _context.workflow"
                [activity]="localActivity"
                [form]="newDEForm"
              ></wm-data-entity-editor>
            </wm-activity-details-modal>
            <button
              type="button"
              class="btn btn-primary dropdown-toggle dropdown-toggle-split"
              ngbDropdownToggle
               *ngIf="showLayoutDropdown"
              [disabled]="_workflowSvc.designerVersionMode || saving"
            >
              <span class="visually-hidden">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu *ngIf="showLayoutDropdown">
              <button
                class="dropdown-item"
                type="button"
                (click)="addRowLayout()"
              >
                Row Layout
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="addGroupLayout()"
              >
                Group Layout
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="addTableLayout()"
              >
                Table Layout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="localActivity.model.formLayoutModel">
    <!-- Single column-->
    <div class="row" *ngIf="localActivity?.model?.formLayout == 0">
      <div class="col">
        <div class="row">
          <div class="col-sm-12 wrapper">
            <ul
              class="list-group cdk-drag-container"
              *ngIf="localActivity.model.formLayoutModel"
              cdkDropList
              [id]="mainDropListId"
              [cdkDropListData]="layoutEntities"
              [cdkDropListConnectedTo]="connectedDropLists"
              [cdkDropListDisabled]="isFiltered"
              (cdkDropListDropped)="dropMain($event)"
            >
              <li
                class="list-group-item form-entity-item d-flex align-items-center"
                cdkDrag
                [cdkDragData]="de"
                [cdkDragDisabled]="isFiltered"
                *ngFor="
                  let de of filterEntities(
                    sortEntities(
                      localActivity.model.formLayoutModel.columnEntities
                    ),
                    true
                  )
                "
              >
                <i
                  cdkDragHandle
                  class="material-icons text-muted me-2 drag-handle"
                  style="cursor: grab;"
                  onmousedown="this.style.cursor='grabbing'"
                  onmouseup="this.style.cursor='grab'"
                  >drag_handle</i
                >
                <div class="flex-grow-1" style="min-width: 0;">
                  <wm-data-entity-item
                    #entityItem
                    [de]="de"
                    [workflow]="workflow"
                    [activity]="localActivity"
                    [extraToolButtons]="extraToolButtons"
                    (deleteEntity)="removeDataEntity(de)"
                    (editEntity)="viewDataEntity(de)"
                    (saveEntity)="saveDataEntity(de)"
                    (saveActivity)="onSaved($event)"
                  >
                  </wm-data-entity-item>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
